/**
 * @generated SignedSource<<8368d89ae06c2f3501789bf854aabb3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgAdminTopicsEditDeleteMutation$variables = {
  topicId: string;
};
export type OrgAdminTopicsEditDeleteMutation$data = {
  readonly organisation: {
    readonly topic: {
      readonly archiveTopic: {
        readonly id: string;
      };
    };
  };
};
export type OrgAdminTopicsEditDeleteMutation = {
  response: OrgAdminTopicsEditDeleteMutation$data;
  variables: OrgAdminTopicsEditDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "topicId"
          }
        ],
        "concreteType": "TopicMutation",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "archiveTopic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsEditDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgAdminTopicsEditDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "466df1bbe4c1db17a50d42f7ded7b129",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsEditDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminTopicsEditDeleteMutation(\n  $topicId: ID!\n) {\n  organisation {\n    topic(id: $topicId) {\n      archiveTopic {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "310ac287cd703e1d0f5b4777a4bc1721";

export default node;
